import { addProjectProductsToAmplify } from "reedy-data/api";
import { BaseApi } from "./base";

export class ProjectsApi extends BaseApi {
  async addProductsToAmplify(projectId: string, productIds: string[]) {
    const response = await this.request(addProjectProductsToAmplify, {
      path: { project_id: projectId },
      body: { productIds },
    });

    return response?.data;
  }
}
